import BaseService from '@src/services/BaseService'

class PosNotVisitedService extends BaseService {
    constructor() {
        super('dashboards/user-info')
    }
}

export default new PosNotVisitedService()
